const showDynamicError  = (messageStr) => {
    // container is in resources/views/layouts/secondary-update.blade.php
    $('#dynamicErrorsContainer').show();
    $(`<li>${messageStr}</li>`).appendTo('#dynamicErrors');
}

const bindManuallyOpenModal = (triggerBtnID, modalID) => {
    $(document).on('click', triggerBtnID, function(){
        $(modalID).modal('show');
    });
}

/**
 * Ensures the given argument is a valid jQuery object.
 * @param {string|jQuery|HTMLElement} selectorOrElement - A selector, jQuery object, or DOM element.
 * @returns {jQuery} A valid jQuery object or an empty one if the input is invalid.
 */
const ensureJqueryEl = (selectorOrElement) => {
    if (selectorOrElement instanceof $) {
        return selectorOrElement;
    }

    if (typeof selectorOrElement === 'string' || (selectorOrElement && selectorOrElement.nodeType === 1)) {
        return $(selectorOrElement);
    }

    console.error("Invalid element provided to function. Expected a string, jQuery object, or HTMLElement.");
    return $();
}

/**
 * Creates a debounced version of a function.
 * @param {function} fn - The function to debounce.
 * @param {number} delay - The delay in milliseconds.
 */
const debounce = (fn, delay) => {
    let timer;
    return function (...args) {
        const context = this;
        clearTimeout(timer);
        timer = setTimeout(() => {
            fn.apply(context, args);
        }, delay);
    };
}

const modalScrollToError = (modalSelector) => {
    const $modal = ensureJqueryEl(modalSelector);
    const errorSelector = '.is-invalid, [aria-invalid="true"], :invalid, .error';
    const $firstError = $modal.find(errorSelector).not('form').filter(':visible').first();

    if ($firstError.length) {
        const element = $firstError[0];

        element.scrollIntoView({
            behavior: 'smooth',
            block: 'center'
        });

        setTimeout(() => {
            $firstError.focus({ preventScroll: true });
        }, 500);
    }
};


const formatMinutes = (minutes) => {
    if(!minutes || minutes <= 0)
        return '';

    minutes = Math.round(minutes * 100) / 100;

    if(minutes < 60)
        return minutes + 'm';

    let hours = Math.floor(minutes / 60);
    minutes   = minutes - (hours * 60);

    return hours + 'h ' + minutes + 'm';
}

const clearValidation = (input) => {
    if (input.hasClass('select2-hidden-accessible') || input.next('.select2-container').length) {
        input.next('.select2-container').next(".error-message").remove();
    } else {
        input.removeClass("is-invalid");
        input.next(".error-message").remove();
    }
}

const failValidation = (input, errorMessage) => {
    clearValidation(input);
    let error = $('<span class="error-message text-danger">' + errorMessage + '</span>');

    // Check if the current element is a Select2 element
    if (input.hasClass('select2-hidden-accessible') || input.next('.select2-container').length) {
        error.insertAfter(input.next('.select2-container'));
    } else {
        input.addClass("is-invalid");
        error.insertAfter(input);
    }
}

window.app.fns.failValidation  = failValidation;
window.app.fns.clearValidation = clearValidation;

export {
    showDynamicError,
    bindManuallyOpenModal,
    ensureJqueryEl,
    debounce,
    modalScrollToError,
    formatMinutes,
    failValidation,
    clearValidation,
};